{% block sw_cms_element_acris_blog_group_preview %}
    <div class="sw-cms-el-preview-acris-blog-group">
        <sw-cms-product-box-preview :has-text="true" />
    </div>
{% endblock %}

